import { render } from "./CompassPerformanceChart.vue?vue&type=template&id=3e2c2225"
import script from "./CompassPerformanceChart.vue?vue&type=script&lang=js"
export * from "./CompassPerformanceChart.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/CompassPerformanceChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e2c2225"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e2c2225', __exports__)) {
    api.reload('3e2c2225', __exports__)
  }
  
  module.hot.accept("./CompassPerformanceChart.vue?vue&type=template&id=3e2c2225", () => {
    api.rerender('3e2c2225', render)
  })

}


export default __exports__